export default {
    turn : {
        account: "會員帳號",
        count: "剩餘次數",
        history: "抽獎紀錄",
        time: "抽獎時間",
        EventsTime: "活動時間",
        EventsActivities: "活動內容",
        to: "至",
        prize: "中獎獎項",
        status: "派獎狀態",
        unpay:  "未派發",
        payed:  "已派發",
        accountError: " 帳號異常",
        contact: " 請聯繫在線客服",
        zero: "抽獎次數為0",
        drawing: "正在抽獎中...",
        congratulations: "恭喜你獲得",
        activityEnds: '活動已結束',
        EndlookIt: '敬請期待下次活動',
        activityStart: '將會開啟活動',
        EventsNotStart: '本活動尚未開始',
        UnderConstruction: '產品建構中',
        StartlookIt: '敬請期待！',
        EventsisEnd: '本活動已經結束',
        ThanksJoin: '感謝您的參與！',
        AccountError: '帳號錯誤',
        DataError: '資料有誤',
        TokenError: '令牌驗證錯誤',
        drawCountEmpty: '抽獎次數不足'
    },
    awards: {
        "0": "1獎",
        "1": "2獎",
        "2": "3獎",
        "3": "4獎",
        "4": "5獎",
        "5": "6獎",
        "6": "7獎",
        "7": "8獎",
        "8": "9獎",
        "9": "10獎"
    },
    level: {
        levelId:  "門檻序號",
        totalBet: "總流水"
    },
    award: {
        awards: "獎項",
        rate:   "機率",
        level:  "門檻 "
    },
    awardLimit: {
        award:     "獎項",
        remaining: "剩餘",
        limit:     "上限",
        unlimit:   "無上限"
    },
    userInfo: {
        all:        "全部",
        platform:   "站台",
        account:    "會員帳號",
        count:      "可抽獎次數",
        totalCount: "總抽獎次數",
        totalBet:   "總流水",
        level:      "門檻 "
    },
    winningRecord: {
        all:          "全部",
        account:      "會員帳號",
        winningTime:  "中獎時間",
        platform:     "站台",
        award:        "獎項",
        status:       "派發狀態",
        action:       "操作",
        unpay:        "未派發",
        payed:        "已派發",
        pay:          "派發",
        previousPage: "上一頁",
        nextPage: "下一頁",
        page: "第 {page} 頁",

    },

    status: {
        enable:     "啟用",
        disabled:   "停用",
        freeze:     "凍結",
        notFreeze:  "非凍結",
        bet:        "可下注",
        notBet:     "不可下注",
        del:        "刪除",
        success:    "成功",
        fail:       "失敗",
        checkAll:   "全選",

        loading:    "載入中",
        searching:  "查詢中",
        search: {
            success: "查詢成功",
            error: "查詢失敗",
        },
        setting: {
            success: "設定成功",
            error: "設定失敗",
        },
        insert: {
            success: "新增成功",
            error: "新增失敗",
        },
        update: {
            success: "更新成功",
            error: "更新失敗",
            nochange: "資料無異動",
        },
        save: {
            success: "儲存成功",
            error: "儲存失敗",
        },
        delete: {
            success: "刪除成功",
            error: "刪除失敗"
        },
        openDraw: {
            success: "開獎成功",
            error: "開獎失敗",
        },
        export: {
            error: "匯出失敗"
        },
        validator: {
            error: "驗證失敗，請檢查輸入資料是否正確",
            initError: "初始資料錯誤",
            resDataFormatError: "接收資料格式錯誤"
        }
    },

    question: {
        confirm: "再次確認",
        update: "是否確定更新？",
        delete: "是否確定刪除？",

        title: {
            delete: "是否確定刪除{title}？",
        }
    },

    time: {
        dateCreate: "創建日期",
        dateUpdate: "更新日期",
        LastLoginDate: "最後登入時間",
        dateScope: "日期範圍",
        rangeSeparator: "至",
        day: "天",
        hour: "時",
        minute: "分",
        second: "秒",
        week: {
            monday:     "星期一",
            tuesday:    "星期二",
            wednesday : "星期三",
            thursday:   "星期四",
            friday:     "星期五",
            saturday:   "星期六",
            sunday:     "星期日"
        }
    },

    button: {
        search: "查詢",
        research: "重新查詢",
        create: "新增",
        addRow: "加入一筆",
        edit:   "編輯",
        update: "更新",
        confirm: "確定",
        close:  "關閉",
        cancel: "取消",
        delete: "刪除",
        stepPrev: "上一步",
        stepNext: "下一步",
        export: "匯出",
        reset: "重置",
        set: "設定",
        save: "儲存",
        saveSet: "儲存設定",
        clear: "清除",
        remove: "移除",
        actions: "操作",


        title: {
            create: "新增{title}",
            update: "更新{title}",
        },
        dateScope: {
            latelyMinutes: "近{minute}分",
            latelyHours: "近{hour}小時",
            yesterday: "上一天",
            today: "今天",
            lastWeek: "上一週",
            thisWeek: "本週",
            lastMonth: "上月",
            thisMonth: "本月"
        }
    },

    dialog: {
        title: {
            create: "新增{title}",
            update: "更新{title}",
        }
    },

    navbar: {
        switchLang: "語言",
        home:       '首頁',
        profile: '個人資訊',
        profilePassword:  '更新密碼',
        logOut:     '登出',
        message: {
            hello: '{msg} 您好',
            switchLangSuccessful: "語系切換成功"
        },
        onlineCount: {
            litteryMary: "視訊小瑪莉"
        }
    },

    profile: {
        identity: {
            name:       "身份",
            company:    "公司",
            companySub: "子帳號",
            agent:      "代理",
            agentSub:   "子帳號",
        },
    },

    siderbar: {
        back: "回主選單",
        filterText: "搜尋代理帳號"
    },

    validator: {
        required: "此欄為必填",
        lenStr: "長度限 {min}~{max} 字",
        minStr: "最少須填寫 {min} 字以上",
        maxStr: "長度限 {max} 字以內",
        lenNum: "需介於 {min}~{max}",
        minNum: "數值須為 {min} (含)以上",
        maxNum: "數值須為 {max} (含)以下",
        type: "型態不符",
    },

    message: {
        warning: {
            dateScope: "請輸入查詢的日期範圍起迄",
            selectDelCheckbox: "請選擇要刪除的資料"
        },
        exportLimit: "最多匯出{row}筆",
    },

    //共用，不分類
    fields: {
        opPass: "操作者密碼",
    },

    router: {
        level: "流水門檻",
        award: "獎項",
        awardLimit: "獎項上限",
        userInfo: "會員資訊",
        winningRecord: "中獎紀錄",
        agent: "代理管理",
        system: "系統管理",
        dashboard: "首頁",
        bulletin: "公告管理",
        game: {
            management: "遊戲管理",
            gametype: "遊戲大類設定",
            games: "遊戲設定",
            maintain: "遊戲維護"
        },
        lottery: {
            management: "彩票管理",
            type: "彩種管理",
            issue: "期數管理",
            source: "即時獎源監控",
            historySource: "數據源列表",
            risk: "玩群風險設定",
            play: "玩法賠率設定",
            draw: "彩票開獎紀錄",
        },
        whitelist: "登入IP白名單",
        handicap: "限紅管理",
        report: {
            title: "報表管理",
            profit: "輸贏報表",
            bet: "投注紀錄",
            lotterybet: "彩票投注紀錄",
            gameResult: {
                title: "遊戲結果",
                littleMary: "小瑪莉",
                fruitevo: "超進化水果盤"
            },
            gameResultTrend : {
                title: "遊戲結果(牌路)",
                littleMary: "小瑪莉(牌路)",
                fruitevo: "超進化水果盤(牌路)"
            },
            profitSimple: "簡易輸贏報表",
            LogTransactionMember: "玩家額度紀錄",
            monthly: "月報表"
        },
        currentBet: "當前投注",
        onlineMember: "在線玩家",
        authority: "權限群組管理",
        marquee: "跑馬燈",
        logOperating: "操作日誌",
        profile: '個人資訊',
        profilePassword: "更新密碼",
        chat: "聊天室管理",
        currency: "幣別管理",
        music: "音樂管理",
        gameMusic: "遊戲音樂管理"
    },

    //擴充自定義原element-ui的設定名稱
    elementUI: {
        datepicker: {
            rangeSeparator: "至",
            startMonth: "開始月份",
            endMonth: "結束月份",
        },
        confirm :{
            check: "是否確定派發?",
            tips: "提示",
            confirm: "確定",
            cancel: "取消",
            canceled: "已取消",
        }
    },

    //共用組件
    transCodeSelect: {
        fieldName: "請選擇交易代碼",
        bet: {
            label: "下注",
            cancel: "取消下注",
            win: "中獎",
            draw: "和局退返本金",
            withhold: "下注預扣款",
            reback: "下注寫單失敗，退還下注金額"
        },
        pointMember: {
            label: "存提款(會員)",
            add: "點數轉入 (API)",
            minus:  "點數轉出 (API)",
            manualAdd: "手動加點",
            manualMinus: "手動扣點"
        }
    },

    //共用組件-更新狀態
    updateStateForm: {
        account: "帳號",
        name: "名稱"
    },

    login: {
        title: '抽獎後台',
        logIn: '登入',
        account: '帳號',
        password: '密碼',
        tokenExpiredTip: '逾時登出，請重新登入'
    },

    agent: {
        name: "代理",
        code: "前綴碼",
        profit: "佔成",
        handicap: "盤口(限紅)",
        setHandicapDefault: "設置新建玩家默認盤口(限紅)",
        manageAuthorityModule: "權限群組管理",
        moduleName: "權限",
        enable: "狀態",
        freeze: "是否凍結",
        bet: "投注狀態",
        operatorPassword: "操作者密碼",
        report: "輸贏報表",
        agentLine: "代理線",
        nextAgentSum: "下線代理總數",
        underMemberSum: "直線玩家",
        upAgent: "上級代理",
        currencyName: "幣別",
        layout: "版型",
        layoutMap: {
            1: "META版",
            2: "OFA版"
        },
        placeholder: {
            account: "至少6-20英數字組合、而且須為小寫字母",
            password: "至少6-20英數字或符號",
            searchAccount: "帳號搜尋"
        },
        tabs: {
            agent: "代理",
            member: "玩家",
            subAgent: "子帳號",
        },
        tagsView: {
            agent: "代理管理",
        },
        handicapList: {
            header: "盤口(限紅)清單",
            title: "普通盤口(限紅)",
            titleVip: "VIP盤口(限紅)",
            col: {
                name: "盤口(限紅)",
                betmin: "下限",
                betmax: "上限",
            }
        },
        handicapDefault: {
            tip: "請選擇1-3默認普通盤口(限紅)",
            tipVip: "請選擇默認VIP盤口(限紅)",
            col: {
                name: "盤口(限紅)",
                betmin: "下限",
                betmax: "上限",
            },
            rules: {
                errorTip: "請勾選1-3項",
                errorTipVip: "請至少勾選1項",
            }
        },
        levelState: {
            title: "層級",
            company: "公司",
            generalAgent: "總代理",
            agent: "代理",
        },
        list: {
            empty: "無下層代理資料",
            nickname: "匿稱",
            handicap: "盤口(限紅)",
            profit: "佔成",
            status: "狀態",
            freeze: "凍結",
            bet: "下注",
            remark: "備註",
        },
        step: {
            info: "基本資訊",
            handicap: "普通盤口(限紅)",
            handicapVip: "VIP盤口(限紅)",
            confirm: "確認",
        },
        info: {
            autoGenerate: "帳號生成方式",
            auto: "自動",
            manual: "手動",
            account: "帳號",
            nickname: "匿稱",
            password: "密碼",
            passwordOld: "原始密碼",
            passwordCheck: "確認密碼",
            passwordNew: "新密碼",
            profit: "佔成",
            remark: "備註",
            module: "權限",
            moduleEmpty: "尚無權限群組資料，請先建立"
        },
        updatePassword: "更改密碼",
        updatePasswordSuccess: "密碼更新成功",
        updateHash: "更新Hash KEY, Hash IV",
        updateHashSuccess: "Hash KEY, Hash IV更新成功",
        rules: {
            passwordCheck: {
                diff: "兩次輸入密碼不一致"
            },
            errorMultipleSelect: "請至少勾選一項"
        },
        formTitle: {
            create: "新增代理",
            edit: "修改代理"
        },
        question: {
            status: "確定要更改代理的帳號狀態？",
            freeze: "確定要更改代理的凍結狀態？",
            bet: "確定要更改代理的投注狀態？",
        },
        gameEnable: {
            title: "遊戲開啟設定"
        },
        button: {
            gameOpen: "遊戲開啟",
            lotteryRiskSetting: "彩票風險設定",
            edit: "編輯資料",
            updatePassword: "更新密碼",
            editOpKey: "編輯外接Key",
        },
        lottery: {
            agentRiskTitle: "代理彩票風險設定",
            agentError: "代理資料錯誤",
            memberRiskTitle: "會員彩票風險設定",
            memberError: "會員資料錯誤",
            specialRisk: "專屬風控設定",
            generalRisk: "一般風控設定",
        }
    },

    subAccount: {
        title: "子帳號",
        empty: "無子帳號資料",
        subAgent: "上級代理",
        AgentAccount: "主帳號",
        account: "帳號",
        password: "密碼",
        passwordCheck: "確認密碼",
        passwordNew: "新密碼",
        nickname: "匿稱",
        status: "狀態",
        moduleName: "權限",
        remark: "備註",
        lastLoginIP: "最後登錄IP",
        module: "權限",
        upAgentLine: "上線",
        operatorPassword: "操作者密碼",
        updatePassword: "更改密碼",
        placeholder: {
            account: "至少6-20英數字組合、而且須為小寫字母",
            password: "至少6-20英數字或符號",
            searchAccount: "帳號搜尋"
        },
        formTitle: {
            create: "新增子帳號",
            edit: "修改子帳號"
        },
        question: {
            status: "確定要更改子帳號的狀態？",
        },
    },

    member: {
        title: "玩家",
        empty: "無玩家資料",
        AgentAccount: "代理帳號",
        account: "帳號",
        password: "密碼",
        passwordCheck: "確認密碼",
        passwordNew: "新密碼",
        nickname: "匿稱",
        handicap: "盤口(限紅)",
        handicapGeneral: "普通盤口(限紅)",
        handicapVip: "VIP盤口(限紅)",
        points: "額度",
        BetMax: "最大限額",
        LoseMax: "最大輸額",
        status: "狀態",
        freeze: "凍結",
        bet: "下注",
        remark: "備註",
        operatorPassword: "操作者密碼",
        placeholder: {
            account: "至少6-20英數字組合、而且須為小寫字母",
            password: "至少6-20英數字或符號",
            searchAccount: "帳號搜尋"
        },
        manualAddPoint: {
            title:  "人工存提",
            button: "人工存提",
            action: "動作",
            add:    "加點",
            minus:  "扣點",
            points: "點數",
            addSuccess: "加點成功",
            minusSuccess: "扣點成功"
        },
        formTitle: {
            create: "新增玩家",
            edit: "修改玩家"
        },
        step: {
            info: "基本資訊",
            handicap: "普通盤口(限紅)",
            handicapVip: "VIP盤口(限紅)",
            confirm: "確認",
        },
        handicapList: {
            header: "盤口(限紅)清單",
            title: "普通盤口(限紅)",
            titleVip: "VIP盤口(限紅)",
            col: {
                name: "盤口(限紅)",
                betmin: "下限",
                betmax: "上限",
            }
        },
        info: {
            autoGenerate: "帳號生成方式",
            auto: "自動",
            manual: "手動",
            account: "帳號",
            nickname: "匿稱",
            password: "密碼",
            passwordCheck: "確認密碼",
            passwordNew: "新密碼",
            betMax: "最大限額",
            loseMax: "最大輸額",
            remark: "備註"
        },
        updatePassword: "更改密碼",
        updatePasswordSuccess: "密碼更新成功",
        rules: {
            passwordCheck: {
                diff: "兩次輸入密碼不一致"
            },
            errorMultipleSelect: "請至少勾選一項"
        },
        question: {
            status: "確定要更改玩家的帳號狀態？",
            freeze: "確定要更改玩家的凍結狀態？",
            bet: "確定要更改玩家的投注狀態？",
        }
    },

    game: {
        gameTypeId: "遊戲大類ID",
        gameTypeName: "遊戲大類名稱",
        gameId: "遊戲ID",
        gameName: "遊戲名稱",
        enable: "啟停用狀態",
        updateEnableSuccess: "更新狀態成功",
        sessionTimeOptions: {
            daily: "每天",
            weekly: "每週",
            monthly: "每月"
        },
        tables: {
            buttonText: "桌號",
            title: "{name} - 桌號控項設定",
            tableName: "遊戲桌號名稱",
            enable: "狀態",
            rtpTip: "範圍為88~99",
            roundTime: "整局時間(秒)",
            closeTime: "封盤秒數",
            forceTime: "封盤後強迫控制時間(秒)",
            roundLimit: "每局賠分上限",
            sessionTime: "賠分週期",
            sessionLimit: "週期賠分上限",
            reacquire: "重複取獎次數上限",
            videoURL: "視訊位址",
            rtplimitup: "RTP上限",
            rtplimitdown: "RTP下限",
            curtplimitup: "幣值RTP上限",
            rules: {
                closeTimeLessThenRoundTime: "封盤秒數 必須小於 整局時間(秒)",
                roundLimitScope: "每局賠分上限需大於等於 0、而且小於 100,000,000",
                sessionLimitScope: "週期賠分上限需大於等於0、而且小於 100,000,000",
                forceTimeScope: "封盤後強迫控制時間(秒) 必須小於 封盤秒數、而且大於0",
                reacquireScope: "重複取獎次數上限需大於0"
            }
        },
        monitor: {
            buttonText: "RTP即時監控",
            title: "{name} - RTP即時監控(以台幣計)"
        },
        question: {
            status: "確定要更改遊戲狀態？",
        },
    },

    littleMary: {
        monitor: {
            onlineCount: "線上人數",
            thisGame: "本局",
            betTotal: "本局總下注",
            betTotalDetail: "本局項目下注總額",
            nobet: "無",
            oncemore: "送燈",
            status: {
                bet: "可下注",
                control: "封盤(可控制)",
                closed: "封盤(開獎)"
            },
            weekly: {
                betTotal: "週期總下注",
                winTotal: "週期總中獎",
                winLoseTotal: "週期輸贏",
                rtp: "週期RTP",
            },
            last90Days: {
                betTotal: "90天內總下注",
                winTotal: "90天內總中獎",
                winLoseTotal: "90天內輸贏",
                rtp: "90天內RTP",
            },
            gameInfo: {
                description: "遊戲資訊：每局{roundTime}秒、最後{closeTime}秒封盤、封盤後{forceTime}秒內可強迫開獎。 計算週期：{sessionTime}，賠分上限(每局/週期)：{roundLimit} / {sessionLimit}",
                more: "更多內容"
            },
            issueInfo: {
                roundTime: "每局時間",
                closeTime: "封盤時間",
                forceTime: "封盤後強迫控制時間",
                sessionTime: "計算週期",
                roundLimit: "每局賠分上限",
                sessionLimit: "週期賠分上限",
                reacquire: "開獎結果重取次數",
                rtp: "設定RTP",
            },
            sessionTime: {
                daily: "每天",
                weekly: "每週",
                monthly: "每月"
            },
            searchBar: {
                tableId: "桌號",
                refresh: "更新頻率",
                filterAgent: "排除代理帳號",
                filterAgentTip: "按ENTER輸入多筆"
            },
            button: {
                closeTable: "關閉本桌遊戲",
                openTable: "開啟本桌遊戲",
                disableBet: "停注",
                kickOut: "踢下線",
            },
            tip: {
                tableClosing: "本桌遊戲關閉中",
                forceOpen: "*強迫開獎將忽視全部限制條件，按下即時寫入",
                // forceOpen2: "*按下強迫開獎即時寫入",
                forceOpenOnceMore: "請填寫1~3組送燈獎",
                forceOpenOnceMoreSort: "如填寫送燈獎項，請依照順序填寫(送燈1→送燈2→送燈3)",
                comboRequired: "{num}顆燈為必填"
            },
            forceOpen: {
                title: "強迫開獎",
                nowRtp: "目前RTP",
                button: "強迫開獎",
                forceOpenRTP: "強迫開獎後RTP",
                forceOpenResult: "強迫開獎後輸贏結果",
                symbol: "圖示",
                odds: "倍數",
            },
            list: {
                memberAccount: "會員帳號",
                memberNickName: "會員暱稱",
                round: "局號",
                betDetail: "下注內容",
                betCount: "注數",
                betTotal: "下注金額",
            },
            message: {
                requiredForceOpen: "請先選擇強迫開獎項目與倍數",
                successForceOpen: "強迫開獎設定完成",
                disableBet: "已將會員 {account} 設為停止下注",
                kickout: "已將會員 {account} 踢下線",
                refreshChanged: "更新頻率已設定為 {seconds} 秒",
                oncemoreAll: "填寫送燈獎項時，請務必填寫倍數",
                oncemoreSort: "請依照順序填寫送燈獎項(送燈1→送燈2→送燈3)",
                atleastonce: "請至少填寫1組送燈獎、最多3組",
                issueError: "查無當期期數資料或控項資料",
                forceOpenCount: "必填填寫{num}顆燈"
            },
            question: {
                closeTable: "是否確定關閉 {name} ？"
            },
            forceType: {
                single: "單顆",
                combo3: "3顆組合大獎",
                combo2: "2顆組合大獎",
            },
            showOdds: "{odds}倍"
        },
        stateOptions: {
            pending:        "未開局",
            enable:         "投注中",
            disable:        "停止下注",
            closed:         "封盤中",
            notOpen:        "未開獎",
            collected:      "已開獎",
            canceled:       "退單",
        },
        issueEnableOptions: {
            enable:  '正常',
            disable: '停止下注'
        },
        symbol: {
            "0": "送燈",
            "1": "BAR",
            "2": "77",
            "3": "星星",
            "4": "西瓜",
            "5": "鈴鐺",
            "6": "芒果",
            "7": "橘子",
            "8": "櫻桃"
        },
        symbolCode: {
            A: "3BAR",
            B: "2BAR",
            C: "1BAR",
            D: "大7",
            E: "小7",
            F: "大星星",
            G: "小星星",
            H: "大西瓜",
            I: "小西瓜",
            J: "大鈴鐺",
            K: "小鈴鐺",
            L: "大芒果",
            M: "小芒果",
            N: "大橘子",
            O: "小橘子",
            P: "櫻桃",
        }
    },

    maintain: {
        title: "遊戲維護",
        typeMap: {
            interval: "時間間隔",
            daily: "每日循環",
            weekly: "每周循環",
            monthly: "每月循環"
        },
        interval: "時間",
        exceptionId: "例外帳號",
        type: "類型",
        enable: "狀態",
        week: "星期",
        day: "日",
        hour: "時",
        minute: "分",
        duringTime: "持續",
        separatedByCommas: "帳號請以,隔開",
        dateStart: "開始時間",
        dateStop: "結束時間",
    },


    whitelist: {
        title: "IP白名單",
        agentAccount: "帳號",
        ip: "IP",
        type: "類型",
        enable: "狀態",
        typeMap: {
            api:   "API白名單",
            agent: "代理白名單"
        },
    },

    handicap: {
        title: "盤口(限紅)資料",
        type: "類型",
        type1: "普通",
        type2: "VIP",
        name: "盤口(限紅)名稱",
        betmin: "下限",
        betmax: "上限",
        enable: "狀態",
    },

    report: {
        profit: {
            title: "輸贏報表",
            tagsView: "輸贏報表",
            searchTimeText: "時間範圍",
            filterAgent: "排除代理帳號(按ENTER輸入多筆)",
            tab: {
                agent: "代理",
                member: "玩家",
                agentEmpty: "無下層代理資料",
                memberEmpty: "無玩家投注資料",
            },
            summary: {
                subTotal: "小計",
                total: "總計"
            },
            gameTypeName: "遊戲大類",
            betTotal: "投注金額",
            effectiveBet: "有效投注",
            profit: "佔成",
            refundTotal: "交上線",
            refundTotalEffective: "交上線有效投注量",
            listSubTotal: "合計",
            agent: {
                realWinnings: "代理輸贏",
                total: "代理總金額",
            },
            member: {
                realWinnings: "玩家輸贏",
                total: "玩家總金額",
            },
            originalCurr: "原始"  //原始幣別
        },
        profitSimple: {
            title: "簡易輸贏報表",
            tagsView: "簡易輸贏報表",
            listSubTotal: "總計",
            subAgentTitle: "下線",
            subMemberTitle: "下線玩家",
            agentTitle: "代理",
            upAgentTitle: "上線",
            agent: "代理",
            member: "玩家",
            sumRealWinnings: "代理總輸贏",
            profit: "佔成",
            realWinnings: "代理輸贏",
            commission: "佣金",
            total: "代理總金額",
            effectiveBet: "玩家有效投注",
            memberRealWinnings: "玩家輸贏",
            memberTotal: "玩家總金額",
        },
        bet: {
            gameName: "遊戲",
            tableName: "桌號",
            round: "局號",
            agents: '代理帳號(查詢多名以","分隔)',
            members: '玩家帳號(查詢多名以","分隔)',
            state: "狀態",
            total: "總計(NTD)",
            summary: {
                betTotal: "投注總金額",
                realWinnings: "玩家總輸贏",
                effectiveBet: "有效總投注",
            },
            betTotal: "投注金額",
            realWinnings: "玩家輸贏",
            effectiveBet: "有效投注",
            agent: "代理",
            member: "玩家",
            betNo: "注單號",
            betDate: "投注時間",
            openDate: "開獎時間",
            openResult: "遊戲結果",
            content: "下注內容",
            stateOptions: {
                notCollect: "未對獎",
                cancel: "取消單",
                lose: "未中獎",
                win: "中獎",
                draw: "和局"
            },
        },
        gameResult: {
            littleMary: {
                tableName: "桌號",
                round: "局號",
                nowTime: "查詢當下時間",
                dateStart: "開始時間",
                dateClose: "封盤時間",
                dateStop: "結束時間",
                dateDraw: "開獎時間",
                openResult: "遊戲結果",
                videoURL: "視訊",
                state: "狀態",
                actions: "功能",
                remark: "備註",
                cancelBet: {
                    button:     "未開獎退單",
                    buttonCancel: "退單",
                    success:    "退單成功",
                    title:      "退單結果",
                    questionTitle: "退單確認",
                    question:   '此操作將取消並且退回 "{tableName}-{round}期" 之所有注單，確定執行退單？',
                    remarkPlaceholder: "請輸入退單原因(字數限{max}字以內)",
                    account:    "帳號",
                    no:         "注單",
                    round:  "桌號/期數",
                    total:  "注單總數",
                    updateSuccess:      "退單成功筆數",
                    updPointFailureNo:  "點數退回失敗筆數",
                    updEnableFailure:   "狀態更新失敗筆數",
                    questionBet: '此操作將取消並且退回 "{tableName}-{round}期" 之注單 {betOrderNo}，確定執行退單？',
                    resultCanNotModify: "注單已開獎或已取消，無需再退單",
                    resultStatusError: "退單失敗，修改注單狀態失敗",
                    resultPointError: "退單失敗，退回點數失敗",
                    tipRoundError: "*局號錯誤",
                    tipNotOpenError: "*到期未開獎",
                    tipNotCollectError: "*已開未對獎",
                    updateSuccessCount: "本次退單數",
                    updateIsCollectedCount: "已對獎不可退單",
                    updateIsCancelCount: "已取消單",
                },
                isOpen: "是否開獎",
                isEnable: "可否下注",
                stateOptions: {
                    pending: "未開局",
                    enable: "投注中",
                    disable: "停止下注",
                    closed: "已封盤",
                    opening: "開獎中",
                    opened_collect: "對獎中",
                    collected: "已派彩"
                }
            }
        },
        logTransMember: {
            listSubTotal: "小計",
            memberList: '玩家帳號(查詢多名以","分隔)',
            memberAccount: '玩家帳號',
            betOrderNo: "注單編號",
            id: "序號",
            dateTran: "操作時間",
            upAgent: "上級代理",
            upAgentLine: "上線",
            transName: "交易類型",
            beforeChangePoint: "交易前餘額",
            income: "玩家收入",
            outgo: "玩家支出",
            afterChangePoint: "交易後餘額",
            creatorAccount: "操作者",
            subTotal: "小計",
            total: "總計",
            totalIncome: "玩家總收入",
            totalOut: "玩家總支出",
            totalDiff: "玩家總收支",
            totalCount: "共 {count} 筆",
            remark: "備註"
        },
        monthly: {
            titleMonth:     "{month} 月",
            week:           "週數",
            dateRange:      "期間",
            betTotal:       "總投注",
            realWinnings:   "總輸贏",
            total:          "總計",
            agent:          "總代理",
            drawerMonth:    "{month} 月  月報表",
            drawerWeek:     "{month} 月 - 第 {week} 週( {dateRange} ) 週報表"
        }
    },

    currentBet: {
        round: "局號",
        agentAccount: "代理帳號",
        memberAccount: "玩家帳號",
        agentAccountPlaceholder: '代理帳號(查詢多名以","分隔)',
        memberAccountPlaceholder: '玩家帳號(查詢多名以","分隔)',
        state: "狀態",
        game: "遊戲",
        openResult: "遊戲結果",
        betTotal: "總投注",
        lastOpenResult: "近50期開獎歷史",
        lastOpenResultDesc: "(由上至下、左至右)",
    },

    onlineMember: {
        agentAccount: "代理帳號",
        memberAccount: "玩家帳號",
        agentAccountPlaceholder: '代理帳號(查詢多名以","分隔)',
        memberAccountPlaceholder: '玩家帳號(查詢多名以","分隔)',
        onlineTotal: "在線人數",
        location: "當前位置",
        lobby: "大廳"
    },

    logOperating: {
        agentAccount:   "代理帳號",
        functionName:   "操作動作",
        postData:       "異動資料",
        state:          "狀態",
        dateCreate:     "操作時間",
    },
    userAgent: {
        location:   "所在地",
        device:     "使用設備",
        browser:    "瀏覽器"
    },
    //for操作日誌顯示使用
    apiRouteMap: {
        API: {
            Login: {
                label:  '登入',
                description: '{Account} 登入'
            },
            Profile: {
                Info: {
                    label: '個人資訊',
                    description: ''
                },
                Logout: {
                    label: '登出',
                    description: '{Account} 登出'
                },
                UpdatePassword: {
                    label: '更新個人密碼',
                    description: ''
                }
            },
            AuthorityModule: {
                Search: {
                    label:          '查詢權限群組',
                    description:    '查詢條件--權限群組名稱：{Name}、啟停用：{Enable}'
                },
                SearchTasks: {
                    label:          '查詢代理之功能權限列表',
                    description:    ''
                },
                SearchModuleList: {
                    label:          '查詢代理之權限群組',
                    description:    ''
                },
                Create: {
                    label:          '新增權限群組',
                    description:    '群組名稱：{Name}、權限：{Authority}'
                },
                Update: {
                    label:          '更新權限群組',
                    description:    '更新權限群組編號：{Id}、權限名稱：{Name}、備註：{Remark}、啟停用：{Enable}、權限：{Authority}'
                }
            },
            Agent: {
                Search: {
                    label:          '查詢代理資料',
                    description:    '查詢代理編號：{Id}'
                },
                SearchAgents: {
                    label:          '查詢下線代理資料',
                    description:    '查詢代理編號 {UpAgentId} 的下線'
                },
                UpdateHandicap: {
                    label:          '設置代理的新建玩家默認盤口(限紅)',
                    description:    '代理編號：{AgentId}、普通盤口：{Handicap}、VIP盤口：{VIPHandicap}'
                },
                GetAgentLineTree: {
                    label:          '查詢代理線',
                    description:    ''
                },
                GetUpAgentLineTree: {
                    label:          '查詢上級代理線',
                    description:    ''
                },
                Create: {
                    label:          '新增代理',
                    description:    '上層代理：{UpAgentId}、帳號：{Account}、密碼：*、暱稱：{NickName}、佔成：{Profit}、普通盤口：{Handicap}、VIP盤口：{VIPHandicap}、權限群組編號：{ModuleId}、備註：{Remark}'
                },
                Update: {
                    label:          '更新代理',
                    description:    '代理編號：{Id}、暱稱：{NickName}、佔成：{Profit}、普通盤口：{Handicap}、VIP盤口：{VIPHandicap}、權限群組編號：{ModuleId}、備註：{Remark}'
                },
                UpdateStatus: {
                    label:          '更新代理狀態',
                    description:    '代理編號：{Id}、凍結：{Freeze} (1: 凍結 / 2: 非凍結)、可否下注：{Bet} (1: 可下注 / 2: 不可下注)、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
                UpdatePassword: {
                    label:          '更新代理密碼',
                    description:    '代理編號：{Id}'
                },
                UpdateHash: {
                    label:          '更新代理HASH KEY',
                    description:    '代理編號：{Id}'
                },
                GameEnableList: {
                    label:          '查詢代理已啟用的遊戲列表',
                    description:    ''
                },
                UpGameEnableList: {
                    label:          '設定代理遊戲',
                    description:    '代理編號：{AgentId}、遊戲類別：{GameTypeId}、列表：{List}'
                },
            },
            Member: {
                Search: {
                    label:          '查詢玩家資料',
                    description:    '代理編號：{AgentId}、玩家帳號：{Account}'
                },
                Create: {
                    label:          '新增玩家',
                    description:    '代理編號：{AgentId}、帳號：{Account}、密碼：*、暱稱：{NickName}、最大限額：{BetMax}、最大輸額：{LoseMax}、普通盤口：{Handicap}、VIP盤口：{VIPHandicap}、備註：{Remark}'
                },
                Update: {
                    label:          '更新玩家資料',
                    description:    '玩家編號：{Id}、暱稱：{NickName}、最大限額：{BetMax}、最大輸額：{LoseMax}、普通盤口：{Handicap}、VIP盤口：{VIPHandicap}、備註：{Remark}'
                },
                UpdateStatus: {
                    label:          '更新玩家狀態',
                    description:    '玩家編號：{Id}、凍結：{Freeze} (1: 凍結 / 2: 非凍結)、可否下注：{Bet} (1: 可下注 / 2: 不可下注)、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
                UpdatePassword: {
                    label:          '更新玩家密碼',
                    description:    ''
                },
                UpdateMemberBet: {
                    label:          '更新玩家下注狀態 ',
                    description:    '玩家編號：{Id}、可否下注：{Bet} (1: 可下注 / 2: 不可下注)'
                },
                ManualAddPoint: {
                    label:          '玩家額度-人工存提',
                    description:    '玩家帳號：{Account}、交易群組代碼：{Group}、交易項目代碼：{Item}、點數:{Points}'
                },
                SearchOnline: {
                    label:          '在線玩家列表',
                    description:    '查詢代理帳號列表：{AgentList}、查詢玩家帳號列表：{MemberList}'
                },
                KickOut: {
                    label:          '在線玩家踢下線',
                    description:    '玩家編號：{MemberId}'
                },
            },
            SubAccount: {
                Search: {
                    label:          '查詢子帳號資料',
                    description:    '代理編號：{AgentId}、子帳號：{Account}'
                },
                Create: {
                    label:          '新增子帳號',
                    description:    '上層代理：{AgentId}、帳號：{Account}、密碼：*、暱稱：{NickName}、權限群組編號：{ModuleId}、備註：{Remark}'
                },
                Update: {
                    label:          '更新子帳號資料',
                    description:    '子帳號編號：{Id}、暱稱：{NickName}、權限群組編號：{ModuleId}、備註：{Remark}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
                UpdateStatus: {
                    label:          '更新子帳號狀態',
                    description:    '子帳號編號：{Id}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
                UpdatePassword: {
                    label:          '更新子帳號密碼',
                    description:    ''
                },
            },
            GameType: {
                Search: {
                    label:          "查詢遊戲類別",
                    description:    ''
                },
                List: {
                    label:          "遊戲類別列表",
                    description:    ''
                },
            },
            Games: {
                Search: {
                    label:          "查詢遊戲",
                    description:    '查詢遊戲類別：{GameTypeId}'
                },
                List: {
                    label:          "查詢遊戲列表",
                    description:    ''
                },
                TableSearch: {
                    label:          "查詢遊戲桌號",
                    description:    '查詢遊戲：{GameId}'
                },
                TableList: {
                    label:          "查詢遊戲列表",
                    description:    ''
                },
                UpdateGameSetting: {
                    label:          "更新遊戲控項",
                    description:    '流水號：{Id}、遊戲類別編號：{GameTypeId}、遊戲編號：{GameId}、桌號：{TableId}、桌號名稱：{TableName}、狀態：{Enable} (1: 啟用 / 2: 停用)、控項內容：{Controller}'
                },
                UpdateGameStatus: {
                    label:          "更新遊戲狀態",
                    description:    '流水號：{Id}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
                UpdateGameTableStatus: {
                    label:          "更新遊戲桌號狀態",
                    description:    '流水號：{Id}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
                RTPInfo: {
                    label:          "查詢遊戲桌號RTP資訊",
                    description:    ''
                },
            },
            Maintain: {
                Search: {
                    label:          '查詢遊戲維護',
                    description:    '遊戲類別：{GameTypeId}、遊戲編號：{GameId}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
                Create: {
                    label:          '新增遊戲維護',
                    description:    '遊戲類別：{GameTypeId}、遊戲編號：{GameId}、維護類型：{Type} (1: 時間區間 / 2: 每日循環 / 3: 每周循環 / 4: 每月循環)、狀態：{Enable} (1: 啟用 / 2: 停用)、例外帳號：{ExceptionId}、時間循環：{Interval}、時間循環：{Interval2}'
                },
                Update: {
                    label:          '更新遊戲維護',
                    description:    '流水號：{Id}、遊戲類別：{GameTypeId}、遊戲編號：{GameId}、維護類型：{Type} (1: 時間區間 / 2: 每日循環 / 3: 每周循環 / 4: 每月循環)、狀態：{Enable} (1: 啟用 / 2: 停用)、例外帳號：{ExceptionId}、時間循環：{Interval}、時間循環：{Interval2}'
                },
            },
            AgentWhiteList: {
                Search: {
                    label:          "查詢白名單",
                    description:    '代理帳號：{AgentAccount}、類別：{Type} (1: API / 2: 代理)、IP：{IP}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
                SearchAvailable: {
                    label:          "已啟用的白名單",
                    description:    ''
                },
                Create: {
                    label:          "新增白名單",
                    description:    '代理帳號：{AgentAccount}、類別：{Type} (1: API / 2: 代理)、IP：{IP}'
                },
                Update: {
                    label:          "更新白名單",
                    description:    '流水號：{Id}、代理帳號：{AgentAccount}、IP：{IP}'
                },
                Delete: {
                    label:          "刪除白名單",
                    description:    '流水號：{Id}'
                },
            },
            Handicap: {
                Search:{
                    label:          "查詢盤口(限紅)",
                    description:    '類別：{Type} (1: 一般 / 2: VIP)、盤口名稱：{Name}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
                List: {
                    label:          "已啟用盤口(限紅)",
                    description:    ''
                },
                Create: {
                    label:          "新增盤口(限紅)",
                    description:    '類別：{Type} (1: 一般 / 2: VIP)、盤口名稱：{Name}、最小下注：{BetMin}、最大下注：{BetMax}'
                },
                Update: {
                    label:          "更新盤口(限紅)",
                    description:    '流水號：{Id}、類別：{Type} (1: 一般 / 2: VIP)、盤口名稱：{Name}、最小下注：{BetMin}、最大下注：{BetMax}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
                UpdateStatus: {
                    label:          "更新盤口(限紅)狀態",
                    description:    '流水號：{Id}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
            },
            Report: {
                Profit: {
                    Search: {
                        label:          "查詢輸贏報表",
                        description:    '代理編號：{AgentId}、開始時間：{StartTime}、結束時間：{EndTime}'
                    },
                    Agent: {
                        label:          "查詢輸贏報表(代理列表)",
                        description:    '代理編號：{AgentId}、開始時間：{StartTime}、結束時間：{EndTime}'
                    },
                    Member: {
                        label:          "查詢輸贏報表(玩家列表)",
                        description:    '代理編號：{AgentId}、開始時間：{StartTime}、結束時間：{EndTime}'
                    },
                },
                ProfitSimple: {
                    Search: {
                        label:          "查詢簡易輸贏報表",
                        description:    '代理編號：{AgentId}、開始時間：{StartTime}、結束時間：{EndTime}'
                    },
                }
            },
            BetOrder: {
                Search: {
                    label:          "查詢投注紀錄",
                    description:    '開始時間：{StartTime}、結束時間：{EndTime}、遊戲編號：{GameId}、局號：{Round}、代理列表：{AgentList}、玩家列表：{MemberList}、已對獎：{Collect}、取消注單：{Cancel} (0: 非取消單 / 1: 客戶取消單 / 2: 系統取消單 / 3:追單中獎取消)、中獎狀態：{State} (0:沒中獎, 1:中獎, 2:和局)'
                },
                SearchByRound: {
                    label:          "查詢遊戲單局的投注紀錄",
                    description:    ''
                },
                SearchSummary: {
                    label:          "查詢遊戲單局的統計值",
                    description:    ''
                },
                SearchCurrent: {
                    label:          "當前投注",
                    description:    '局號：{Round}、開始時間：{StartTime}、結束時間：{EndTime}'
                },
            },
            GameResult: {
                LittleMary: {
                    Search: {
                        label:          "查詢小瑪莉遊戲結果",
                        description:    '開始時間：{StartTime}、結束時間：{EndTime}、局號：{Round}、桌號：{TableId}'
                    },
                    TrendSearch: {
                        label:          "查詢小瑪莉遊戲結果(牌路)",
                        description:    '開始時間：{StartTime}、結束時間：{EndTime}、局號：{Round}、桌號：{TableId}'
                    },
                    ForceOpen: {
                        label:          "小瑪莉強迫開獎",
                        description:    '遊戲編號：{GameId}、桌號：{TableId}、局號：{Round}、圖示：{KeyId}、倍數：{Odds}'
                    },
                    ForceOpenResult: {
                        label:          "小瑪莉強迫開獎後的結果",
                        description:    '查詢條件--遊戲編號：{GameId}、桌號：{TableId}、局號：{Round}、圖示：{KeyId}、倍數：{Odds}'
                    },
                    CancelTimeoutOrders: {
                        label:          "小瑪莉未開獎取消注單",
                        description:    '遊戲編號：{GameId}、桌號：{TableId}、局號：{Round}、備註：{Remark}'
                    },
                }
            },
            Log: {
                TransactionMember: {
                    label:          "查詢玩家交易額度紀錄",
                    description:    '查詢條件--開始時間：{StartTime}、結束時間：{EndTime}、玩家列表：{MemberList}、注單編號：{BetOrderNo}、IP：{IP}、交易群組代碼：{Group}、交易項目代碼：{Item}'
                },
                AgentOperating: {
                    label:          "查詢操作日誌",
                    description:    '查詢條件--開始時間：{StartTime}、結束時間：{EndTime}、代理列表：{AgentList}'
                },
            },
            Bulletin: {
                Search: {
                    label:          '查詢公告',
                    description:    ''
                },
                Create: {
                    label:          '新增公告',
                    description:    '遊戲編號：{GameId}、公告重要性：{Important} (1: 一般公告 / 2: 緊急公告)、公告推播：{Push} (0: 無 / 1: 推播)、公告標題：{Title}、公告內容：{Content}、開始時間：{StartTime}、結束時間：{EndTime}、備註：{Remark}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
                Update: {
                    label:          '更新公告',
                    description:    '流水號：{Id}、遊戲編號：{GameId}、公告重要性：{Important} (1: 一般公告 / 2: 緊急公告)、公告推播：{Push} (0: 無 / 1: 推播)、公告標題：{Title}、公告內容：{Content}、開始時間：{StartTime}、結束時間：{EndTime}、備註：{Remark}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
            },
            Marquees: {
                Search: {
                    label:          '查詢跑碼燈',
                    description:    ''
                },
                Create: {
                    label:          '新增跑碼燈',
                    description:    '遊戲編號：{GameId}、跑馬燈內容：{Content}、開始時間：{StartTime}、結束時間：{EndTime}、備註：{Remark}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
                Update: {
                    label:          '更新跑碼燈',
                    description:    '流水號：{Id}、遊戲編號：{GameId}、跑馬燈內容：{Content}、開始時間：{StartTime}、結束時間：{EndTime}、備註：{Remark}、狀態：{Enable} (1: 啟用 / 2: 停用)'
                },
            },
            Config: {
                Search: {
                    label:          '基本設定',
                    description:    ''
                },
            },
        },
    },

    authority: {
        title: "權限群組",
        name: "權限群組名稱",
        usedCount: "使用人數",
        enable: "啟停用",
        remark: "備註",
        authority: "權限功能",
        agentAccount: "代理帳號",
        task: "功能說明",
        privilegeOptions: {
            none: "無",
            all: "最大權限",
            read: "只可查詢"
        },
        placeholder: {
            select: "全部權限"
        },
        tabs: {
            first: "權限列表",
            second: "使用者列表"
        },
        type: "類型"
    },
    bulletin: {
        "name": "公告管理",
        "id" : "編號",
        "title" : "標題",
        "content" : "公告內容",
        "gameType" : "遊戲大類",
        "game" : "遊戲",
        "enable" : "狀態",
        "bulletinTime" : "公告時間",
        "dateCreate" : "建立時間",
        "important" : "公告重要性",
        "normal" : "一般公告",
        "urgent" : "緊急公告",
        "remark" : "備註",
        "push" : "公告推播",
        "no": "無",
        "yes": "推播",
        oneatleast: "請至少輸入一筆",
        titleRequired: "請填寫 {lang} 的標題",
        contentRequired: "請填寫 {lang} 的公告內容"
    },

    marquee: {
        "name": "跑馬燈管理",
        "id" : "編號",
        "content" : "跑馬燈內容",
        "gameType" : "遊戲大類",
        "game" : "遊戲",
        "enable" : "狀態",
        "marqueeTime" : "跑馬燈時間",
        "dateCreate" : "建立時間",
        "important" : "跑馬燈重要性",
        "normal" : "一般跑馬燈",
        "urgent" : "緊急跑馬燈",
        "remark" : "備註",
        "push" : "跑馬燈推播",
        "no": "無",
        "yes": "推播"
    },

    apiErrorCode: {
        1001: "參數錯誤",
        1002: "內部錯誤(sql)",
        1003: "內部錯誤(redis)",
        1004: "新增失敗(sql)",
        1005: "新增失敗(redis)",
        1006: "更新失敗(sql)",
        1007: "更新失敗(redis)",
        1008: "",

        1020: "圖片大小超過限制",

        1101: "IP格式錯誤",

        7004: "HashKey or HashIv 錯誤",

        2001: "登入失敗(帳號或密碼錯誤、已停用、無登入權限)",
        2002: "Token錯誤或已失效",
        2003: "帳號已存在",
        2004: "查無上層代理線",
        2005: "新增代理資料失敗(insert語法有誤)",
        2006: "新增代理線資料失敗(insert語法有誤)",
        2007: "自動生成代理代碼錯誤",
        2008: "查無上層代理資料",
        2009: "查無代理資料",
        2010: "權限不足(Forbidden)",
        2011: "設定未完成",
        2012: "帳號不屬於操作者直屬下線",
        2013: "無此筆資料操作權限",
        2014: "權限群組編號不屬該代理",
        2015: "操作者密碼錯誤",
        2016: "非總代理，不可更新幣別",
        2017: "非總代理",

        2031: "查無子帳號資料",
        2032: "子帳號不屬於登入者代理所屬",

        2051: "查無權限群組資料",
        2052: "尚無設定權限",
        2053: "權限已被使用，無法修改",

        2101: "遊戲token錯誤",
        2102: "server token錯誤",
        2103: "找不到登入資料",
        2104: "找不到會員 (帳號不存在)",
        2105: "帳號已存在",
        2106: "帳號已凍結",
        2107: "帳號無法下注",
        2108: "帳號已停用",
        2109: "帳號不存在於操作者代理線",
        2110: "點數異動代號錯誤",
        2111: "手動加扣點失敗",
        2113: "資料已經存在",
        2114: "會員餘額不足",
        2115: "會員餘額更新失敗",
        2116: "新增會員資料失敗(insert錯誤)",
        2117: "更新會員資料失敗",
        2118: "更新會員資料失敗",

        2201: "跑馬燈新增失敗",
        2202: "跑馬燈更新失敗",
        2203: "跑馬燈排序失敗",

        2211: "公告新增失敗",
        2212: "公告更新失敗",

        2221: "輪播圖新增失敗",
        2222: "輪播圖更新失敗",

        2231: "盤口名稱已存在",
        2232: "代理盤口不存在",
        2233: "會員盤口不存在",

        3001: "找不到遊戲",

        3101: "遊戲控項型態錯誤",
        3102: "遊戲控項設定錯誤",
        3103: "下注項目錯誤",
        3104: "局號錯誤",
        3105: "該局已關盤",
        3106: "至少有一個下注項目",
        3107: "下注失敗",
        3108: "限紅錯誤",
        3109: "注單不存在",
        3110: "非當前局號",
        3115: "更新失敗(已封盤)",
        3116: "更新失敗(已結束)",

        3120: "取消注單失敗",

        3201: "遊戲大類已存在",
        3202: "遊戲大類不存在",
        3203: "遊戲已存在",
        3204: "遊戲不存在",
        3205: "遊戲桌已存在",
        3206: "遊戲桌不存在",
        3207: "遊戲大類已停用",
        3208: "遊戲已停用",
        3209: "遊戲桌已停用",
        3210: "遊戲維護中",

        4001: "查無彩種資料",
        4002: "查無期數資料",
        4003: "無法手動開獎(可能已開獎或已刪單)",
        4004: "無法手動開獎(未結束)",
        4005: "手動開獎結果驗證錯誤，請檢查遊戲開獎規則",
        4006: "本期資料已無法修改",
    },
    musicApiErrorCode: {
        1001: "帶入參數錯誤",
        1002: "音樂資料寫入DB失敗",
        1003: "音樂資料更新DB失敗",
        1004: "取得資料失敗",
        1005: "遊戲音樂資料寫入DB失敗",
        100: "尋找ffmpeg程式失敗",
        101: "Youtube網址匹配失敗",
        102: "找不到影片",
        103: "取得影片詳細資料失敗",
        104: "建立檔案失敗",
        105: "檔案複製失敗",
        106: "linux系統轉檔失敗",
        107: "windows系統轉檔失敗",
        108: "抓不到OS系統可用程式",
        109: "linux系統刪除檔案失敗",
        110: "windows系統刪除檔案失敗",
        111: "複製MP3時，開啟檔案失敗",
        112: "複製MP3時，建立檔案失敗",
        113: "複製MP3時，複製檔案失敗",
        114: "音樂秒數超過限制",
        115: "音量調整失敗",
        116: "語系缺少參數",
        117: "查無此音樂",
        118: "volume值過大",
        119: "查無桌號資料",
        120: "請輸入要設定的遊戲",
        121: "請輸入GameTypeId",
        122: "此音樂已停用",
        123: "狀態未變動",
        124: "遊戲音樂重複加入"
    },

    formula: {
        betTotal:               "(未取消單的)總投注金額",            //投注總金額
        effectiveBetTotal:      "投注總金額 - (雙面對押 + 未開獎)",  //有效總投注
        effectiveBet:           "投注金額 - (雙面對押 + 未開獎)",    //有效投注
        playerRealWinnings:     "總投注金額 - 總中獎金額",           //玩家輸贏
        agentRealWinnings:      "(總投注金額 - 總中獎金額) × -1",    //代理輸贏
        realWinningsPercents:   "(輸贏 / 有效投注 ) × 100",         //% = (輸贏 / 有效投注 ) × 100
        total:                  "輸贏 - 優惠活動",                  //總金額
        refundTotalPercents:    "(100% - 代理佔成%) / 100",         //交上線百分比
        refundTotal:            "交上線% × 總金額",                 //交上線
        refundTotalEffective:   "交上線% × 有效投注量",             //交上線有效投注量
        empty:                  "尚無提示"
    },
    chat: {
        editConfig:     "編輯聊天室設定檔",
        deleteMessage:  "刪除訊息",
        deleteMessageAll:  "刪除全部訊息",
        cancelDelete:   "取消刪除",
        messagePlaceholder: "請輸入內容開始聊天(限{chatMessageLimit}字)",
        sendMessage:    "發送訊息",
        filterPlaceholder: "輸入後按Enter可新增多筆過濾詞",
        questionDelete: "確定要刪除已選擇的訊息?",
        questionAllDelete: "確定要刪除全部訊息?",
        filterWords:    "聊天室過濾詞語",
        messageLimit:   "聊天室訊息保留筆數",
        messageMax:     "聊天室每則訊息長度限制",
        clearEveryday:  "聊天室是否每日定時清除",
        message: {
            isConn:         "聊天室連線中",
            isReading:      "讀取聊天室資訊",
            openConfigError: "查詢設定檔錯誤",
            errorConn:      "無連線至聊天室",
            selectRoom:     "請選擇聊天室，開始傳訊息",
            empty:          "尚無聊天訊息"
        }
    },
    currency: {
        title: "幣別",
        id: "幣別編號",
        code: "幣別代碼",
        name: "幣別名稱",
        rate: "匯率",
        enable: "狀態"
    },
    music: {
        title: "音樂",
        musicName: "歌曲顯示名稱",
        enable: "啟停用",
        button: {
            create:         "新增音樂",
            edit:           "編輯音樂",
            editdB:         "調整音量",
            add:            "加入音樂",
            gameAddMusic:   "遊戲加入音樂",
            gameUsed:       "使用中遊戲列表",
            musicUsed:      "使用中音樂清單",
        },
        id: "編號",
        index: "序",
        youtubeUrl: "youtube網址",
        volume: "音量大小",
        lang: "適用語系",
        tryToPlay: "音樂試聽",
        remark: "備註",
        gameSelect: "遊戲選擇",
        gameTypeName: "遊戲大類",
        gameName: "遊戲",
        tableName: "桌號",
        actions: "功能",
        newAdd: "新加入",
        searchMusicNamePlaceholder: "輸入歌曲顯示名稱搜尋",
        volumePlaceholder: "預設89dB",
        langPlaceholder: "請選擇適用語系(可多選)",
        message: {
            musicExists: "音樂已存在清單",
            addMusicSuccess: "音樂已成功加入清單",
            removeNewMusic: "只可移除新加入音樂",
            emptyNewMusic: "無新加入音樂",
            musicNameTip: "請至少輸入一種語言的歌曲名稱",
            musicNameTip2: "儲存時，如為空值的語言，將自動補上第一筆有填寫的歌曲名稱",
            addGameTipTitle: "加入提示",
            addGameTip1: "請選擇「遊戲大類、遊戲」再做加入。",
            addGameTip2: '如已設定遊戲，則無法再設定桌，例如：已設定音樂加入"視訊/小瑪莉"，則無需再加入"視訊/小瑪莉/水果派對"。',
            addGameTip3: '如已設定桌，則無法再設定遊戲，如要設定必須先刪除桌的資料，再設定遊戲，例如：已設定音樂加入"視訊/小瑪莉/水果派對"，則無法再加入"視訊/小瑪莉"，如要加入，請先刪除"視訊/小瑪莉/水果派對"後，即可做加入。',
            deleteMusicTip: '"{game}"的音樂"{music}"'
        },
        validator: {
            youtubeUrl: "此欄為必填，而且需為https://開頭",
            musicName: "請至少輸入一種語言的歌曲名稱",
            gameRequired: "請先選擇遊戲大類、遊戲",
            addGameRowError: "加入失敗，請勿重複設定資料"
        }
    },
    lottery: {
        lotteryTypeGroup:       "彩群編號",
        lotteryTypeGroupName:   "彩群名稱",
        lotteryType:            "彩種編號",
        lotteryTypeName:        "彩種名稱",
        lotteryPlayGroup:       "玩群編號",
        lotteryPlayGroupName:   "玩群名稱",
        lotteryPlay:            "玩法編號",
        lotteryPlayName:        "玩法名稱",
        lotteryContent:         "項目編號",
        lotteryContentName:     "項目名稱",
        lotteryMod:             "分類",
        lotteryTypTitle:        "彩種",
        lastBetTime:            "開獎前最後下注時間(秒)",
        cycle:                  "期數編碼規則",
        info:                   "彩票玩法規則",
        seq_start:              "年度流水起始編號",
        openFreq:               "開獎頻率",
        drawTimeOut:            "開獎逾時秒數",
        index:                  "序",
        enable:                 "狀態",
        issue:                  "期數",
        betEnable:              "可否下注",
        openResult:             "開獎結果",
        openResult2:            "第二組開獎結果",
        dateStart:              "開盤時間",
        dateClose:              "封盤時間",
        dateStop:               "結束時間",
        dateCurrent:            "所屬日期",
        dateDraw:               "開獎時間",
        drawManual:             "開獎模式",
        dateDrawSource:         "獎源開獎時間",
        drawCollect:            "已對獎",
        drawCancel:             "刪單",
        drawOpenStatus:         "開獎狀態",
        drawSourceStatus:       "獎源狀態",
        remark:                 "備註",
        manualOpenDraw:         "手動開獎",
        btnOpenDraw:            "進行開獎",
        btnDeleteSpecRisk:      "刪除專屬風控設定",
        odds:                   "賠率",
        modOption: {
            highFreq:   "高頻彩",
            lowFreq:    "低頻彩",
            official:   "官方彩",
            selfOpen:   "自開彩"
        },
        lottType: {
            message: {
                issueRule: "期數編號從 {start} ~ {end}、每{freqSec}秒開1期、起始時間: {startat}",
                rule1: "開獎號碼：{NumMin} ~ {NumMax}",
                rule2: "每期開出 {NumCount} 個號碼",
                rule3: "開獎號碼不可重複",
                rule4: "每一位位置的開獎號碼可以重複",
                rule5: "每天共{IssueSum}期",
                rule6: "期數編碼規則「年月日(各2碼)+流水號({IssueSeq}碼)」",
            }
        },
        option: {
            enable:     "可下注",
            disable:    "停止下注",
            auto:       "自動",
            manual:     "手動",
            normal:     "正常單",
            cancel:     "刪單",
            collect:    "已對獎",
            notCollect: "未對獎",
        },
        validator: {
            dateStartMustGreaterThenDateClose: "封盤時間必須大於開盤時間",
            dateCloseMustLessThenDateStop: "封盤時間不可超過本期開獎時間",
            errorLotteryType: "查無彩種"
        },
        issueDraw: {
            editIssueTimeTitle: "修改期數時間",
            updateSuccess:      "期數時間更新成功",
            betTotal:           "投注額(注數/總金額)",
            firstOpenSource:    "最早開獎源",
            sourceName:         "數據源",
            sourceList:         "獎源列表",
            issueClass:         "期別",
            lastIssue:          "前期",
            currentIssue:       "本期",
            drawSource:         "歷史數據",
            status: {
                1: "正常",
                2: "手動開獎",
                3: "提早開獎"
            }
        },
        sourceNameMap: {
            "3": "招財貓"
        },
        playGroup: {
            selectType: "選擇彩種",
            message: {
                selectTip1: "以第一個勾選的彩種，帶出其設定值",
                selectTip2: "更新時，會更新設定值到已勾選的彩種",
                required: "所有欄位均為必填，只可輸入數字 (單注最小投注額，可輸入數字或小數點)",
                betMinLimitCompareBetMaxLimit:  "單注最小投注額 不可超過 單注最大下注",
                betMinLimitCompareCompany:      "代理的「單注最小投注額」不可低於公司設定值",
                betMaxLimitCompareCompany:      "代理的「單注最大投注額」不可高於公司設定值",
                betWinningLimitCompareCompany:  "代理的「單注獎金上限」不可高於公司設定值",
                betCountLimitCompareCompany:    "代理的「單期注數上限」不可高於公司設定值",
                issueLimitCompareCompany:       "代理的「單期下注上限」不可高於公司設定值",
                winningLimitCompareCompany:     "代理的「單期獎金上限」不可高於公司設定值",
                getDefaultAgentError:           "代理預設值資料查詢錯誤",
                getDefaultAgentRowsError:       "代理預設值資料筆數錯誤",
                betMinLimitCompareDefaultAgent:      "「單注最小投注額」不可低於代理預設值",
                betMaxLimitCompareDefaultAgent:      "「單注最大投注額」不可高於代理預設值",
                betWinningLimitCompareDefaultAgent:  "「單注獎金上限」不可高於代理預設值",
                betCountLimitCompareDefaultAgent:    "「單期注數上限」不可高於代理預設值",
                issueLimitCompareDefaultAgent:       "「單期下注上限」不可高於代理預設值",
                winningLimitCompareDefaultAgent:     "「單期獎金上限」不可高於代理預設值",
            },
            name:           "玩法設定",
            singleSetting:  '單注設定',
            issueSetting:   '單期設定',
            betMinLimit:    "單注最小投注額",
            betMaxLimit:    "單注最大投注額",
            betWinningLimit: "單注獎金上限",
            betCountLimit:  "單期注數上限",
            issueLimit:     "單期下注上限",
            winningLimit:   "單期獎金上限",
            defaultAgentRisk:   "代理預設值",
            companyRisk:        "公司設定值",

        },
        pk10: {
            resultRank: "第{index}名",
            play: {
                champion:       "冠軍",
                secondPlace:    "亞軍",
                thirdPlace:     "第三名",
                fourthPlace:    "第四名",
                fifthPlace:     "第五名",
                sixthPlace:     "第六名",
                seventhPlace:   "第七名",
                eightPlace:     "第八名",
                ninthhPlace:    "第九名",
                tenthPlace:     "第十名",
            },
            message: {
                range: "請完整填寫開獎結果，必須為數字、並且號碼在 {NumMin} ~ {NumMax} 之間",
                noRepeat: "獎號不可重複",
                confirm: "彩種： {LotteryTypeName}<br>期數： {Issue}<br>獎號：<br>{OpenResult}<br>開獎時立即對獎，請再次確認獎號是否正確？"
            }
        },
        shishi: {
            resultBall1: "萬",
            resultBall2: "千",
            resultBall3: "百",
            resultBall4: "十",
            resultBall5: "個",
        },
        bullseye: {
            resultBall: "獎號{index}"
        },
        cancelBet: {
            confirmBetNo: '此操作將取消並且退回"{issue}期"之注單號{betOrderNo}，確定執行退單？',
            confirmAll:   '此操作將取消並且退回{LotteryTypeName}第{Issue}期之所有注單，確定執行退單？',
            issue:  "彩種/期數",
        },
        betContentMap: {
            number: "號碼",
            rank: "名次",
            unlocated: "不定位",
            big: "大",
            small: "小",
            single: "單",
            double: "雙",
            prime: "質",
            combined: "合",
            dragon: "龍",
            tiger: "虎",
            leopard: "豹子",
            straight: "順子",
            pair: "對子",
            semiShun: "半順",
            miscellaneous: "雜六",
            notSelected: "自選不中",
            rankNum: "個名次",
            sumOftwo: "冠亞和值",
            combinationOftwo: "冠亞組合",
            positioning: "名次定位",
            rankDouble: "名次雙面",
            directElection: "前三名直選",
            baccarat: "百家樂",
            player: "閒",
            banker: "莊",
            tie: "和",
            fiveStar: "五星",
            fourStar: "四星",
            threeStar: "三星",
            twoStar: "二星",
            oneStar: "一星",
            threeBefore: "前三碼",
            threeCenter: "中三碼",
            threeAfter: "後三碼",
            duplexSelectionDirectly: "直選複式",
            singleSelectionDirectly: "直選單式",
            groupSelection: "組選",
            singleNumber: "單號",
            doubleNumber: "二重號",
            threeNumber: "三重號",
            fourNumber: "四重號",
            groupOfThreeDuplexes: "組三複式",
            groupOfThree: "組選三",
            groupOfThreeSingle: "組三單式",
            groupOfSixDuplexes: "組六複式",
            groupOfSixSingle: "組六單式",
            twoBefore: "前二碼",
            twoAfter: "後二碼",
            groupOfTwoDuplexes: "組二複式",
            groupOfTwoSingle: "組二單式",
            oneStarLocated: "一星定位",
            singleWay: "單式",
            notPositioned: "不定位",
            threeBeforeGetOne: "前三一碼",
            threeCenterGetOne: "中三一碼",
            threeAfterGetOne:  "後三一碼",
            threeBeforeGetTwo: "前三二碼",
            threeCenterGetTwo: "中三二碼",
            threeAfterGetTwo:  "後三二碼",
            fourAfterGetOne:   "後四一碼",
            fourAfterGetTwo:   "後四二碼",
            fiveStarGetTwo:    "五星二碼",
            fiveStarGetThree:  "五星三碼",
            doubleSided: "雙面",
            stray: "串關",
            doubleSidedStray: "雙面串關",
            twoStray: "兩星串關",
            threeStray: "三星串關",
            fourStray: "四星串關",
            fiveStray: "五星串關",
            fiveSum: "五球總和",
            showHand: "梭哈",
            fullHouse: "葫蘆",
            fiveOfAKind: "五條",
            fourOfAKind: "四條",
            threeOfAKind: "三條",
            twoPair: "兩對",
            onePair: "一對",
            scatter: "散號",
            bullfighting: "鬥牛",
            bull: "牛",
            bullTwo: "牛牛",
            bullBig: "牛大",
            bullSmall: "牛小",
            bullSingle: "牛單",
            bullDouble: "牛雙",
            nobull: "無牛",
            threeSum: "三球總和",
            firstThreeSum: "前三總和",
            middleThreeSum: "中三總和",
            lastThreeSum: "後三總和",
            selectionNumber: "選號",
            direction: "方位",
            upMiddleDown: "上中下盤",
            up: "上",
            middle: "中",
            down: "下",
            oddTieEven: "奇和偶盤",
            odd: "奇",
            even: "偶",
            sum: "總數",
            bigSingle: "大單",
            smallSingle: "小單",
            bigDouble:  "大雙",
            smallDouble: "大雙",
            fiveElements: "五元素",
            gold:  "金",
            wood:  "木",
            water: "水",
            fire:  "火",
            earth: "土",
            index: "指數",
            posNegLimits: "正負極限",
            perPoint: "每點金額"
        }
    },
    languageMap: {
        "zh-tw":    "繁體中文",
        "zh-cn":    "簡體中文",
        "en":       "英語",
        "pt":       "葡萄牙語",
        "vi":       "越南語"
    },
    //DB key-name 對應表
    db: {
        gameType: {
            "1": "視訊",
            "2": "電子",
            "3": "真人",
            "4": "彩票",
            "5": "體育",
        },
        game: {
            "1": {
                "1": "小瑪莉",
                "2": "超進化水果盤"
            }
        },
        gameTable: {
            "1": {
                "1": {
                    "1": "水果派對",
                    "2": "歡樂熊貓",
                    "3": "小瑪莉"
                },
                "2": {
                    "1": "瑪力歐",
                    "2": "快打旋風",
                    "3": "炸彈超人"
                }
            }
        },
        task: {
            agent:      "代理管理",
            gameType:   "遊戲大類設定",
            games:      "遊戲設定",
            maintain:   "遊戲維護",
            whitelist:  "登入IP白名單",
            handicap:   "限紅管理",
            "report-profit":                "輸贏報表",
            "report-profitSimple":          "簡易輸贏報表",
            "report-bet":                   "投注紀錄",
            "report-gameResult":            "遊戲結果",
            "report-gameResultTrend":       "遊戲結果(牌路)",
            "report-logTransactionMember":  "玩家額度紀錄",
            "currentBet":       "當前投注",
            "onlineMember":     "在線玩家",
            "logOperating":     "操作日誌",
            "authority-module": "權限群組管理",
            bulletin:           "公告管理",
            marquee:            "跑馬燈管理",
            gameIssue:          "期數管理",
            chat:               "聊天室管理",
            currency:           "幣別管理",
            music:              "音樂管理",
            gameMusic:          "音樂遊戲管理"
        },
        currency: {
            "0": "",
            "1": "台幣",
            "2": "人民幣",
            "3": "美元",
            "4": "菲律賓披索",
            "5": "馬幣",
            "6": "大老爺專用馬幣",
            "7": "新加坡幣"
        }
    }
  }



// WEBPACK FOOTER //
// ./src/lang/zh-tw.js